import _ from '@lodash';
import { AppBar, DialogActions, DialogContent, Divider, IconButton, TextField, Toolbar, Tooltip, Typography, withStyles } from '@material-ui/core';
import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import XAPPDialog from 'app/Core/Components/Dialog/XAPPDialog';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import * as AppActions from 'app/store/actions';
import withReducer from 'app/store/withReducer';
import classNames from 'classnames';
import MobileDetect from 'mobile-detect';
import React from 'react';
import { MdClose, MdSave } from 'react-icons/md';
import { RiHealthBookLine } from 'react-icons/ri';
import { VscClearAll } from 'react-icons/vsc';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as Actions from './Store/Actions/ModeloActions';
import ModeloReducer from './Store/Reducers/ModeloReducer';

const md = new MobileDetect(window.navigator.userAgent);

const styles = (theme) => ({
    labelModel: {
        maxWidth: '80px',
        maxHeight: '72px',
        height: '72px',
        // width: '80px'
    },
    divider: {
        width: 1,
        height: 'auto',
        margin: 0,
    },
    divIcones: {
        overflowX: 'auto',
        overflowY: 'hidden',
    }
});

const NewState = {
    open: false,
    idmodelo: null,
    idpessoa: null,
    descricao: "",
    conteudo: null,
    tipo: null,
    funcionalidade: null,
    campos: null
}

class ModeloApp extends XAPPComponent {

    state = { ...NewState };

    componentDidMount() {
        this.initState();
        this.getModelos();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.Reducer.error) {
            this.props.showMessage({
                message: this.props.Reducer.error,
                variant: 'error'
            });
            this.props.Reducer.error = null;
        }
        if (this.props.Reducer.warning) {
            this.props.showMessage({
                message: this.props.Reducer.warning,
                variant: 'warning'
            });
            this.props.Reducer.warning = null;
        }
        if (this.props.Reducer.info) {
            this.props.showMessage({
                message: this.props.Reducer.info,
                variant: 'success'
            });
            this.props.Reducer.info = null;
        }

        if (this.props.conteudo !== null && !_.isEqual(this.props.conteudo, prevProps.conteudo)) {
            //var AConteudo = {};
            this.setState({ conteudo: this.props.conteudo });
        }

        if (this.props.meusmodelos !== undefined && this.props.meusmodelos !== null &&
            !_.isEqual(this.props.meusmodelos, prevProps.meusmodelos)) {
            this.initState();
        }

        if (!prevState.open && this.state.open && !_.isUndefined(this.props.Formulario) && !_.isNull(this.props.Formulario)) {
            this.setCamposModelo(this.props.Formulario);
        }
    }

    initState = () => {
        const { xappRouteParams } = this.props;
        var AState = JSON.parse(JSON.stringify(this.state));
        AState.idpessoa = xappRouteParams.empresa;
        AState.tipo = this.props.tipo;
        AState.funcionalidade = this.props.funcionalidade;
        this.setState(AState);
    }

    openDialog = (_AValue) => {
        this.setState({ open: _AValue });
    }

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value));
    };

    canBeSubmitted = () => {
        const { descricao, conteudo, funcionalidade } = this.state;
        return (
            descricao !== null && descricao !== '' &&
            conteudo !== null && conteudo !== '' &&
            funcionalidade !== null && funcionalidade !== ''
        );
    }

    actionSave = (_AAction) => {
        const form = JSON.parse(JSON.stringify(this.state));
        const { save, xappRouteParams } = this.props;
        var AConteudo = {};
        var AFilter = { AND: [{ Campo: "funcionalidade", Operador: "=", Valor: this.props.funcionalidade }] };
        if (!_.isUndefined(this.props.tipo) && !_.isNull(this.props.tipo)) {
            AFilter.AND.push({ Campo: "tipo", Operador: "=", Valor: this.props.tipo });
        }
        Object.keys(form.campos).forEach(key => {
            AConteudo[key] = form.conteudo[key];
        });
        form.conteudo = AConteudo;
        save(_AAction, form, xappRouteParams, AFilter);
        this.setState({ idmodelo: null, descricao: null, conteudo: null, open: false });
    }

    getModelos = () => {
        var AFilter = { AND: [{ Campo: "funcionalidade", Operador: "=", Valor: this.props.funcionalidade }] };
        if (!_.isUndefined(this.props.tipo) && !_.isNull(this.props.tipo)) {
            AFilter.AND.push({ Campo: "tipo", Operador: "=", Valor: this.props.tipo });
        }
        this.props.list("SELECIONAR", this.props.xappRouteParams, AFilter);
        this.setState({ idmodelo: null });
    }

    setModelo = (_AItem) => {
        const { setModelo } = this.props;
        this.setState({ idmodelo: _AItem.idmodelo, descricao: _AItem.descricao, conteudo: _AItem.conteudo });
        setModelo(_AItem);
    }

    setCamposModelo = (_AFormulario) => {
        var AResponse = {};
        _AFormulario.body.forEach((groupitem) => {
            groupitem.campos.forEach((fielditem) => {
                if (fielditem.salvarmodelo) {
                    AResponse[fielditem.id] = fielditem.salvarmodelo;
                }
            });
        });
        this.setState({ campos: AResponse });
    }

    render() {
        const form = this.state;
        const { icon, modelo, meusmodelos, classes, setModelo } = this.props;
        var AModelo = {};
        if (!_.isNull(form.idmodelo)) {
            AModelo = _.find(meusmodelos, { idmodelo: form.idmodelo });
        }

        return (
            <React.Fragment>
                <div className="flex w-full">
                    <Tooltip title={"Salvar modelo"} placement={"top"}>
                        <IconButton
                            className=""
                            onClick={() => this.openDialog(true)}
                            key={"iconModeloSalvar"}
                        >
                            <MdSave className="text-20" />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={"Limpar modelo"} placement={"top"}>
                        <IconButton
                            className=""
                            onClick={() => this.setModelo({ idmodelo: null, descricao: null, conteudo: null })}
                            key={"iconModeloLimpar"}
                        >
                            <VscClearAll className="text-20" />
                        </IconButton>
                    </Tooltip>
                    <Divider className={classes.divider} />
                    <Typography className="text-16 p-12" color="inherit">{AModelo.descricao}</Typography>
                </div>
                <Divider className={classes.divider} />
                {meusmodelos !== null &&
                    <div className={classNames(classes.divIcones, "flex flex-row w-full items-top")}>
                        {meusmodelos.map(item => (
                            // <Tooltip title={item.descricao} placement={"top"}>
                            <IconButton
                                className=""
                                onClick={() => this.setModelo(item)}
                                key={"iconModelo" + item.descricao}
                            >
                                <div className={classNames(classes.labelModel, "justify-center")}>
                                    <RiHealthBookLine className="text-32" />
                                    <Typography className="text-12" color="inherit">{item.descricao.substring(0, 22)}</Typography>
                                </div>
                            </IconButton>
                            // </Tooltip>
                        ))}
                    </div>
                }
                <XAPPDialog
                    id="Modelo"
                    open={form.open}
                    fullWidth
                    maxWidth="xs"
                    onClose={() => this.openDialog(false)}
                >
                    <AppBar position="static" elevation={1}>
                        <Toolbar className="flex w-full min-h-0">
                            <Typography variant="subtitle1 text-white">
                                {form.idmodelo === null ? 'Novo modelo' : 'Atualizar modelo'}
                            </Typography>
                            <div style={{ flex: 1 }} />
                            <IconButton
                                key="close"
                                aria-label="Close"
                                className="p-6"
                                className="p-6"
                                onClick={() => this.openDialog(false)}
                            >
                                <MdClose className="text-20 text-white" />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <DialogContent classes={{ root: "p-24" }}>
                        <TextField
                            className="my-8"
                            label={"Descrição"}
                            id="descricao"
                            name="descricao"
                            value={form.descricao}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            multiline
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </DialogContent>
                    <AppBar position="static" elevation={3} color="textSecondary">
                        <Toolbar className="flex w-full justify-end min-h-0">
                            <DialogActions>
                                {form.idmodelo === null ?
                                    <XAPPButton
                                        id="btnInserirModelo"
                                        type="Button"
                                        className="bg-green hover:bg-green text-white mr-8"
                                        variant="contained"
                                        color="primary"
                                        disabled={!this.canBeSubmitted()}
                                        onClick={() => this.actionSave("INSERIR")}
                                        iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                        icon={"save"}
                                        label={md.mobile() === null && md.tablet() === null ? "Salvar" : ""}
                                    />
                                    :
                                    <React.Fragment>
                                        <XAPPButton
                                            id="btnInserirModelo"
                                            type="Button"
                                            className="bg-green hover:bg-green text-white mr-8"
                                            variant="contained"
                                            color="primary"
                                            disabled={!this.canBeSubmitted()}
                                            onClick={() => this.actionSave("ATUALIZAR")}
                                            iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                            icon={"save"}
                                            label={md.mobile() === null && md.tablet() === null ? "Salvar" : ""}
                                        />
                                        <XAPPButton
                                            id="btnInserirModelo"
                                            type="Button"
                                            className="bg-grey-darker hover:bg-grey-darker text-white mr-8"
                                            variant="contained"
                                            color="primary"
                                            disabled={!this.canBeSubmitted()}
                                            onClick={() => this.actionSave("INATIVAR")}
                                            iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                            icon={"block"}
                                            label={md.mobile() === null && md.tablet() === null ? "Remover" : ""}
                                        />
                                    </React.Fragment>
                                }
                            </DialogActions>
                        </Toolbar>
                    </AppBar>
                </XAPPDialog>
            </React.Fragment>
        )
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        save: Actions.save,
        list: Actions.list,
        showMessage: AppActions.showMessage
    }, dispatch);
}

function mapStateToProps({ Modelo }) {
    return {
        Reducer: Modelo,
        meusmodelos: Modelo.meusmodelos
    }
}

export default withStyles(styles, { withTheme: true })(withReducer('Modelo', ModeloReducer)(withRouter(connect(mapStateToProps, mapDispatchToProps)(ModeloApp))));
